import React, { useEffect, useContext, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Layout from './Layout';
import Header from './Header';
import Box from '@mui/material/Box';
import { BusinessContext } from '../context/BusinessContext';
import { ReviewsContext } from '../context/ReviewsContext';

const API_URL = process.env.REACT_APP_API_URL;

const LayoutWithHeader = ({ children, userRole }) => {
  const { selectedBusiness, updateSelectedBusiness } = useContext(BusinessContext);
  const { setReviewsData } = useContext(ReviewsContext);
  const timeoutRef = useRef(null);
  const pollingStartedRef = useRef(false);

  useEffect(() => {
    // If no business or business is not pending, do nothing.
    if (!selectedBusiness || selectedBusiness.status !== 'pending') {
      pollingStartedRef.current = false;
      return;
    }
    // If already polling, exit.
    if (pollingStartedRef.current) return;

    pollingStartedRef.current = true;
    const pollBusiness = async () => {
      console.log('Polling business...');
      try {
        const resBusiness = await fetch(`${API_URL}/users/selected_business`, {
          method: 'GET',
          credentials: 'include',
        });
        if (resBusiness.ok) {
          const updatedBusiness = await resBusiness.json();
          console.log('Polled business status:', updatedBusiness.status);
          updateSelectedBusiness(updatedBusiness);
          if (updatedBusiness.status !== 'pending') {
            // Business is complete—fetch reviews and stop polling.
            const resReviews = await fetch(`${API_URL}/reviews/`, {
              method: 'GET',
              credentials: 'include',
            });
            if (resReviews.ok) {
              const reviewsResponse = await resReviews.json();
              setReviewsData(reviewsResponse.reviews || []);
            }
            pollingStartedRef.current = false;
            return;
          }
        }
      } catch (error) {
        console.error('Error polling selected business:', error);
      }
      // Schedule next poll if still pending.
      if (pollingStartedRef.current) {
        setTimeout(pollBusiness, 10000);
      }
    };

    pollBusiness();
  }, [selectedBusiness, updateSelectedBusiness, setReviewsData]);

  return (
    <Layout userRole={userRole}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}>
        <Header userRole={userRole} />
        <Box sx={{
          flexGrow: 1,
          overflow: { xs: 'auto', lg: 'auto' }, // Ensure scrollable on all devices
          position: 'relative',
          height: { xs: 'calc(100% - 64px)', lg: 'calc(100% - 88px)' }, // Adjust header height based on breakpoint
          maxHeight: { xs: 'calc(100% - 64px)', lg: 'calc(100% - 88px)' }, // Add max-height constraint
          display: 'flex',
          flexDirection: 'column'
        }}>
          {children}
        </Box>
      </Box>
    </Layout>
  );
};

export default LayoutWithHeader;
